import { useEffect, useState } from "react";
import { adminApi } from "@/lib/api";
import { AdminSelect, EmptyState, FieldLabel } from "@/components/admin/AdminUI";

const MODULES = [
  { value: "", label: "All modules" },
  { value: "auth", label: "Auth" },
  { value: "leads", label: "Leads" },
  { value: "pages", label: "Pages" },
  { value: "projects", label: "Projects" },
  { value: "testimonials", label: "Testimonials" },
  { value: "team", label: "Team" },
  { value: "services", label: "Services" },
  { value: "media", label: "Media" },
  { value: "settings", label: "Settings" },
];

export default function AdminActivity() {
  const [logs, setLogs] = useState([]);
  const [module, setModule] = useState("");

  useEffect(() => {
    const params = { limit: 200 };
    if (module) params.module = module;
    adminApi.activity(params).then(setLogs);
  }, [module]);

  return (
    <div className="space-y-6">
      <div className="admin-card rounded-sm p-4 md:p-5 grid md:grid-cols-3 gap-3 items-end">
        <label>
          <FieldLabel>Module</FieldLabel>
          <AdminSelect value={module} onChange={(e) => setModule(e.target.value)}>
            {MODULES.map((m) => <option key={m.value} value={m.value}>{m.label}</option>)}
          </AdminSelect>
        </label>
      </div>

      {logs.length === 0 ? (
        <EmptyState title="No activity logged yet" />
      ) : (
        <div className="admin-card rounded-sm overflow-hidden">
          <table className="w-full text-sm font-body">
            <thead>
              <tr className="text-left border-b border-white/8 bg-white/[0.02] text-[11px] uppercase tracking-[0.14em] text-brand-gray">
                <th className="px-4 py-3">When</th>
                <th className="px-4 py-3">Module</th>
                <th className="px-4 py-3">Action</th>
                <th className="px-4 py-3">Summary</th>
                <th className="px-4 py-3">User</th>
              </tr>
            </thead>
            <tbody>
              {logs.map((l) => (
                <tr key={l.id} className="border-b border-white/6 hover:bg-white/[0.02]">
                  <td className="px-4 py-3 whitespace-nowrap text-brand-gray text-xs">{new Date(l.created_at).toLocaleString()}</td>
                  <td className="px-4 py-3 uppercase text-xs tracking-widest text-brand-yellow">{l.module}</td>
                  <td className="px-4 py-3 text-xs">{l.action}</td>
                  <td className="px-4 py-3">{l.summary}</td>
                  <td className="px-4 py-3 text-brand-gray text-xs">{l.user || "system"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
